const timelineModules = document.querySelectorAll('.timeline-module');
if (timelineModules.length > 0) {
  const timelineModuleOptions = {
    slidesPerView: 'auto',
    spaceBetween: 0,
    freeMode: true,

    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1200: {
        freeMode: false,
      },
    },
  };

  timelineModules.forEach((el) => {
    const parentElem = el.closest('.timeline-module');
    const sliderElem = el.querySelector('[data-slider]');

    const arrowLeft = parentElem.querySelector('.swiper-button-prev');
    const arrowRight = parentElem.querySelector('.swiper-button-next');

    timelineModuleOptions.navigation.prevEl = arrowLeft;
    timelineModuleOptions.navigation.nextEl = arrowRight;

    new Swiper(sliderElem, timelineModuleOptions);

    // Grouping of timeline slides
    document.addEventListener('DOMContentLoaded', () => {
      const timelineGroups = document.querySelectorAll('[data-slide-group]');

      // Create a Map to group elements by their data-slide-group value
      const groups = new Map();

      timelineGroups.forEach((item) => {
        const groupKey = item.getAttribute('data-slide-group');

        if (!groups.has(groupKey)) {
          groups.set(groupKey, []);
        }

        groups.get(groupKey).push(item);
      });

      // Iterate over each group and process elements
      groups.forEach((groupItems) => {
        if (groupItems.length > 0) {
          // Add classes to first and last elements
          groupItems[0].classList.add('group-start');
          groupItems[groupItems.length - 1].classList.add('group-end');

          // Get the first and last element in the group
          const firstElement = groupItems[0];
          const lastElement = groupItems[groupItems.length - 1];

          // Calculate the total width based on bounding box
          const totalWidth = lastElement.getBoundingClientRect().right - firstElement.getBoundingClientRect().left;

          // Find .timeline-module__item-group-text inside this group and set its width
          const groupText = firstElement
            .closest('[data-slide-group]')
            .querySelector('.timeline-module__item-group-text');
          if (groupText) {
            groupText.style.width = `${totalWidth + 28}px`;
          }
        }
      });
    });
  });
}
